import ManageTagModal from './ManageTagModal';

export default ManageTagModal;
